module.exports = __webpack_public_path__ + "img/water-monitor-active.066d73b0.png";